<div class="customer-service-search-border customer-care-multiselect no-padding">
  <div class="col-md-12 no-padding form-horizontal position-relative mt-3">
    <!-- Ticket # -->
    <div class="row no-margin">
      <div class="child_1 col-xs-12 col-lg-6 p-0">
        <label for="{{'ticketing-system.Ticket Number' |translate}}"
          class="control-label col-xs-1 col-lg-2 right-padding-0">{{'ticketing-system.Ticket Number' |translate}}</label>
        <div class="col-sm-7 col-md-5 col-lg-8 floating-input floatLabelContainer">
          <input #ticketNumber id="ticketNumber" autofocus float-label [(ngModel)]="ticketSearchModel.ticketNumber"
            class="form-control" placeholder="{{'ticketing-system.Ticket #' |translate | translateKey}}" tabindex="0"
            type="text" (blur)="searchWithTicketNumber()" (keyup.enter)="onSearch()">
        </div>
        <!-- <div class="col-sm-4 col-md-6 col-lg-7">
            <span>{{ticketSearchModel.ticketNumber}}</span>
          </div> -->
      </div>
      <!-- email -->
      <div class="child_2 col-xs-12 col-lg-6 p-0">
        <label for="Email" class="control-label col-xs-1 right-padding-0 ">{{'ticketing-system.Email' |translate}}</label>
        <div class="col-sm-7 col-md-5 col-lg-8 floating-input floatLabelContainer">
          <input id="email" float-label tabindex="0" class="form-control"
            placeholder="{{'ticketing-system.Email Address' |translate}}" tabindex="1" type="email" autofocus
            [(ngModel)]="ticketSearchModel.email" #emailname="ngModel"
            pattern="^[a-zA-Z0-9_+-]+(\.[a-zA-Z0-9_+-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$" (blur)="searchWithTicketNumber()"
            (keyup.enter)="onSearch()">
          <div class="alert-msg" *ngIf="emailname?.errors?.pattern">
            {{'validation-message.Enter a valid email address'|translate | translateKey}}
          </div>
        </div>
      </div>
    </div>
    <!-- Country Office # -->
    <div class="row no-margin">
      <label for="ticketNumber"
        class="control-label col-xs-1 right-padding-0">{{'ticketing-system.Country Office' |translate}}</label>
      <div class="col-sm-7 col-md-5 col-lg-4 floating-input floatLabelContainer">
        <angular2-multiselect autofocus tabindex="0" (keyup.enter)="openDropDown('countryassignTo')"
          id="countryassignTo" (change)="onDeptChange()"
          [data]="dropdownSettings.countryDropdownList" [(ngModel)]="dropdownSettings.countrySelectedItems"
          [settings]="countryDropdownSettings" (onSelect)="onItemSelect($event,dropdownSettings.countryIndex)"
          (onDeSelect)="onItemDeSelect($event,dropdownSettings.countryIndex)"
          (onSelectAll)="onSelectAll($event,dropdownSettings.countryIndex)"
          (onDeSelectAll)="onDeSelectAll($event,dropdownSettings.countryIndex)">
        </angular2-multiselect>
      </div>
      <div class="col-sm-4 col-md-6 col-lg-7"
        *ngIf="countryOnSelectAll && dropdownSettings.countrySelectedItems.length > 0">
        {{'ticketing-system.ALL' |translate | translateKey}}
      </div>
      <div class="col-sm-4 col-md-6 col-lg-7" *ngIf="!countryOnSelectAll">
        <span *ngFor="let countryassignTo of dropdownSettings.countrySelectedItems| slice:0:8 ; let i=index">
          {{countryassignTo.itemName}}
          <span *ngIf="(dropdownSettings.countrySelectedItems.length-1 > i) && !(i > 6)"> | </span>
        </span>
        <span class="addmore-link"
          *ngIf="dropdownSettings.countrySelectedItems.length > 8">{{'ticketing-system.and more' |translate |translateKey}}</span>
      </div>
    </div>
    <!-- Assign To -->
    <div class="row no-margin">
      <label for="{{'ticketing-system.Assign to User' |translate}}"
        class="control-label col-xs-1 right-padding-0">{{'ticketing-system.Assign to User' |translate}}</label>
      <div class="col-sm-7 col-md-5 col-lg-4 floating-input">
        <angular2-multiselect tabindex="0" (keyup.enter)="openDropDown('teamassignTo')" id="teamassignTo"
          [data]="dropdownSettings.assignedToDropdownList" [(ngModel)]="dropdownSettings.assignedToSelectedItems"
          [settings]="dropdownSettings.settings" (onSelect)="onItemSelect($event,dropdownSettings.assignedToIndex)"
          (onDeSelect)="onItemDeSelect($event,dropdownSettings.assignedToIndex)"
          (onSelectAll)="onSelectAll($event,dropdownSettings.assignedToIndex)"
          (onDeSelectAll)="onDeSelectAll($event,dropdownSettings.assignedToIndex)">
        </angular2-multiselect>
      </div>
      <div class="col-sm-4 col-md-6 col-lg-7"
        *ngIf="assignToOnSelectAll && dropdownSettings.assignedToSelectedItems.length > 0">
        {{'ticketing-system.ALL' |translate | translateKey}}
      </div>
      <div class="col-sm-4 col-md-6 col-lg-7" *ngIf="!assignToOnSelectAll">
        <span *ngFor="let teamassignTo of dropdownSettings.assignedToSelectedItems| slice:0:8 ; let i=index">
          {{teamassignTo.itemName}}
          <span *ngIf="(dropdownSettings.assignedToSelectedItems.length-1 > i) && !(i > 6)"> | </span>
        </span>
        <span class="addmore-link"
          *ngIf="dropdownSettings.assignedToSelectedItems.length > 8">{{'ticketing-system.and more' |translate |translateKey}}</span>
      </div>
    </div>

    <!-- Status -->
    <div class="row no-margin">
      <label for="{{'ticketing-system.Status' |translate}}"
        class="control-label col-xs-1 right-padding-0">{{'ticketing-system.Status' |translate}}
      </label>

      <div class="col-sm-7 col-md-5 col-lg-4 floating-input ">
        <angular2-multiselect tabindex="0" (keyup.enter)="openDropDown('teamstatus')" id="teamstatus"
          [data]="dropdownSettings.statusDropdownList" [(ngModel)]="dropdownSettings.statusSelectedItems"
          [settings]="dropdownSettings.settings" (onSelect)="onItemSelect($event,dropdownSettings.statusIndex)"
          (onDeSelect)="onItemDeSelect($event,dropdownSettings.statusIndex)"
          (onSelectAll)="onSelectAll($event,dropdownSettings.statusIndex)"
          (onDeSelectAll)="onDeSelectAll($event,dropdownSettings.statusIndex)">
        </angular2-multiselect>
      </div>
      <div class="col-sm-4 col-md-6 col-lg-7" *ngIf="!statusOnSelectAll">
        <span *ngFor="let status of dropdownSettings.statusSelectedItems ; let i=index">{{status.itemName}}
          <span *ngIf="(dropdownSettings.statusSelectedItems.length-1 > i) && !(i > 2)"> | </span>

        </span>
      </div>
      <div class="col-sm-4 col-md-6 col-lg-7"
        *ngIf="statusOnSelectAll && dropdownSettings.statusSelectedItems.length > 0">
        {{'ticketing-system.ALL' |translate | translateKey}}
      </div>
    </div>
    <div class="row no-margin">
    </div>
    <div class="pull-right button-block">
      <button class="btn blue-button" #searchbutton id="searchbutton" tabindex="0" type="submit"
      [disabled]="((ticketNumber.value && emailname.value) || !emailname.valid)"
        (keyup.enter)="onSearch()" type="button" (click)="onSearch()">{{'ticketing-system.Search' |translate}}</button>
      <button class="btn grey-button" tabindex="0" type="button"
        (click)="isClearClicked=true;clearFields()">{{'ticketing-system.CLEAR' | translate | translateKey}}</button>
    </div>
  </div>

  <div class="col-md-12 no-padding card margintop-32">

    <div class="table-responsive">
      <div class="alert-msg text-align-center" *ngIf="isFormInvalid">
        <span>{{'ticketing-system.Please choose at least one ticket from the list' | translate| translateKey}}</span>
      </div>
      <table class="tickets-display table table-striped custab ticket-dashbaord">
        <thead>
          <tr>
            <th class="width-20">
              <div>
                <input type="checkbox" tabindex="0" [(ngModel)]="selectAll"
                  (change)="onTicketSelect($event,formTickets,true)">
              </div>
            </th>
            <th class="width-30 pointer" tabindex="0" (click)="sortTableByColumn('TICKET_NUMBER')">
              {{'ticketing-system.Ticket #' |translate}}&nbsp;<i class="fa fa-sort"
                [ngClass]="{'fa-sort': sortColumn != 'TICKET_NUMBER', 'fa-sort-asc': (sortColumn  == 'TICKET_NUMBER' && !isDesc), 'fa-sort-desc': (sortColumn  == 'TICKET_NUMBER' && isDesc) }"
                style="font-size:12px"></i>

            </th>
            <th class="width-30 pointer" tabindex="0" (click)="sortTableByColumn('OPERATING_COUNTRY')">
              {{'ticketing-system.Country Office' |translate}}&nbsp;<i class="fa fa-sort"
                [ngClass]="{'fa-sort': sortColumn != 'OPERATING_COUNTRY', 'fa-sort-asc': (sortColumn  == 'OPERATING_COUNTRY' && !isDesc), 'fa-sort-desc': (sortColumn  == 'OPERATING_COUNTRY' && isDesc) }"
                style="font-size:12px"></i>

            </th>
            <th class="width-40" >
              {{'ticketing-system.Assigned to User' |translate}}&nbsp;</th>
            <th class="width-40">
              {{'ticketing-system.Ticket Type' |translate}}&nbsp;
            </th>
            <th class="width-40 pointer" (click)="sortTableByColumn('SUBTYPE')">
              {{'ticketing-system.Ticket SubType' |translate}}&nbsp;<i class="fa fa-sort"
                [ngClass]="{'fa-sort': sortColumn != 'SUBTYPE', 'fa-sort-asc': (sortColumn  == 'SUBTYPE' && !isDesc), 'fa-sort-desc': (sortColumn  == 'SUBTYPE' && isDesc) }"
                style="font-size:12px"></i>
            </th>
            <th class="width-25 pointer" (click)="sortTableByColumn('STATUS')">
              {{'ticketing-system.Status' |translate}}&nbsp;<i class="fa fa-sort"
                [ngClass]="{'fa-sort': sortColumn != 'STATUS', 'fa-sort-asc': (sortColumn  == 'STATUS' && !isDesc), 'fa-sort-desc': (sortColumn  == 'STATUS' && isDesc) }"
                style="font-size:12px"></i>
            </th>
            <th class="width-35 pointer" tabindex="0" (keyup.enter)="sortTableByColumn('CREATED_DATE')"
              (click)="sortTableByColumn('CREATED_DATE')">
              {{'ticketing-system.Created Date' |translate |translateKey}}&nbsp;&nbsp;
              <i class="fa fa-sort"
                [ngClass]="{'fa-sort': sortColumn != 'CREATED_DATE', 'fa-sort-asc': (sortColumn  == 'CREATED_DATE' && !isDesc), 'fa-sort-desc': (sortColumn  == 'CREATED_DATE' && isDesc) }"
                style="font-size:12px"></i>
            </th>
            <th class="width-35 pointer" tabindex="0" (keyup.enter)="sortTableByColumn('UPDATED_DATE')"
              (click)="sortTableByColumn('UPDATED_DATE')">{{'ticketing-system.Last Modified Date' |translate}}&nbsp;
              <i class="fa fa-sort"
                [ngClass]="{'fa-sort': sortColumn != 'UPDATED_DATE', 'fa-sort-asc': (sortColumn  == 'UPDATED_DATE' && !isDesc), 'fa-sort-desc': (sortColumn  == 'UPDATED_DATE' && isDesc) }"
                style="font-size:12px"></i>
            </th>

          </tr>

        </thead>
        <tbody>
          <tr
            *ngFor="let ticket of formTickets | paginate: {  id: 'form-tickets-pagination', itemsPerPage: pageSize, currentPage: isBulkAssignSearch ? bulkAssignReq.pageNumber : pageNumber, totalItems: pageCount }">
            <td><input tabindex="0" type="checkbox" value="true" [checked]="ticket.isSelected"
                (change)="onTicketSelect($event,[ticket])"></td>
            <td *ngIf="isTicketView"><a tabindex="0" (keyup.enter)="goToViewTicket(ticket.id,ticket.ticketNumber,true)"
                (click)="goToViewTicket(ticket.id,ticket.ticketNumber,true)">{{ticket.ticketNumber}}</a></td>
            <td style="text-transform:capitalize;">{{ticket.operatingCountryName}}</td>
            <td>{{ticket.assignedToValue}}</td>
            <td>{{ticket.ticketType}}</td>
            <td>{{ticket.subType}}</td>
            <td>{{ticket.status}}</td>
            <td>{{ticket.createdDate}}</td>
            <td>{{ticket.modifiedDate | date: 'dd-MMM-yyyy'}}</td>
          </tr>
        </tbody>

        <tbody *ngIf="formTickets?.length === 0">
          <tr>
            <td colspan="9" class="text-center" style="text-align: center">
              {{'ticketing-system.No records found' | translate | translateKey}}.</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="alert-white rounded grid-count">
      <div>
        {{pageCount}} {{'ticketing-system.record(s) found' |translate}}
      </div>
      <pagination-controls [id]="paginationInstance.id" (pageChange)="pageChange($event)" class="pull-right">
      </pagination-controls>
      <div class="pull-left margin_top-5">
        <select tabindex="0" [(ngModel)]="pageSize" class="form-control" (change)="pageChange(1)">
          <option *ngFor="let pageSize of pageSizes" [value]="pageSize">
            {{pageSize}}</option>
        </select>
      </div>
    </div>
  </div>
  <div *ngIf="ticketSpamOrUnspamForm" class="mb-35">
    <form [formGroup]="ticketSpamOrUnspamForm" novalidate>
      <a *ngIf="dropdownSettings.statusSelectedItems.length === 1 && dropdownSettings.statusSelectedItems[0].id === closed ;else elseBlock"
        (keyup.enter)="selectTicketAsSpamOrUnspam(ticketSpamOrUnspamForm.value)"
        (click)="selectTicketAsSpamOrUnspam(ticketSpamOrUnspamForm.value)">{{'ticketing-system.Mark Selected Tickets as Unspam' |translate}}</a>
      <ng-template #elseBlock><a (keyup.enter)="selectTicketAsSpamOrUnspam(ticketSpamOrUnspamForm.value)"
          (click)="selectTicketAsSpamOrUnspam(ticketSpamOrUnspamForm.value)">{{'ticketing-system.Mark Selected Tickets as Spam' |translate}}</a>
      </ng-template>
    </form>
  </div>
  <div *ngIf="ticketAssignForm && selectedCountries.length === 1"
    class="col-md-12 no-padding form-horizontal">
    <form [formGroup]="ticketAssignForm" novalidate (ngSubmit)="submitForm(ticketAssignForm.value)">
      <div class="row no-margin">
        <label for="{{'ticketing-system.Assign to User' |translate}}"
          class="control-label col-xs-1 right-padding-0 bulkassign-text">{{'ticketing-system.Bulk Assign' | translate | translateKey}}</label>
        <div class="col-xs-3 floating-input">
          <select tabindex="0" formControlName="assignToId" class="form-control">{{assignToId}}
            <option value="" selected>{{'ticketing-system.Assign to User' |translate}}</option>
            <option *ngFor="let teamassignTo of bulkTicketAssignees" [value]="teamassignTo.id">{{teamassignTo.name}}
            </option>
          </select>
          <div class="alert-msg"
            *ngIf="!ticketAssignForm.controls['assignToId'].valid && (ticketAssignForm.controls['assignToId'].touched || isSubmitted)">
            {{'order.Assign To is Mandatory' |translate |translateKey}}
          </div>
          <div><button class="btn blue-button pull-right my-10" tabindex="0"
              type="submit">{{'ticketing-system.Assign' | translate | translateKey}}</button></div>
        </div>
        <div class="col-md-8">
        </div>
      </div>
    </form>
  </div>
</div>

<modal #spamOrUnspamTicketConfirmationModal>
  <modal-header>
    <h4 class="color-blue">{{'ticketing-system.Confirmation' |translate}}</h4>
  </modal-header>
  <modal-content>
    <div
      *ngIf="dropdownSettings.statusSelectedItems.length === 1 && dropdownSettings.statusSelectedItems[0].id === closed;else elseBlock"
      class="">
      {{'ticketing-system.Are you sure you want to unspam all the selected tickets?' | translate}}
    </div>
    <ng-template #elseBlock>
      <div class="">
        {{'ticketing-system.Are you sure you want to spam all the selected tickets?' | translate}}
      </div>
    </ng-template>
  </modal-content>
  <modal-footer>
    <div class="pull-right">
      <button class="btn blue-button" type="button" tabindex="0" (keyup.enter)="spamorUnspamSelectedTickets()"
        (click)="spamorUnspamSelectedTickets()">
        {{'ticketing-system.Confirm' |translate}}
      </button>
      <button class="btn blue-button" type="button" tabindex="1"
        (keyup.enter)="closeSpamOrUnpsamTicketConfirmationPopup()" (click)="closeSpamOrUnpsamTicketConfirmationPopup()">
        {{'ticketing-system.Cancel' |translate}}
      </button>
    </div>
  </modal-footer>
</modal>



// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/form-tickets.component.html